import TextArea from 'lib/ui/TextField/TextArea'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'
import {Widget} from 'Event/Widget/template'

export default function AllowedOriginsConfig(props: {
  widget: Widget | null
  updateWidget: (updatedFields: Partial<Widget>) => void
}) {
  const {widget, updateWidget} = props

  if (!widget) {
    return <Skeleton height={80} />
  }

  const handleOriginChange = (value: string) => {
    const updatedOrigins = value.split('\n')
    updateWidget({allowed_origins: updatedOrigins})
  }

  return (
    <>
      <TextArea
        rows={3}
        variant="outlined"
        onChange={handleOriginChange}
        value={widget.allowed_origins?.join('\n') ?? ''}
        inputProps={{
          'aria-label': 'widget allowed origins',
        }}
      />
      <small>
        <i>
          One per line. Leave blank to allow all origins{' '}
          <b>(not recommended).</b>
        </i>
      </small>
    </>
  )
}
